import React from 'react';
import { useStyles } from './ErrorPage.styles';
import AnnouncementIcon from '@material-ui/icons/AnnouncementOutlined';
import Layout from '../Layout/Layout.component';
import ViewContainer from '../ViewContainer/ViewContainer.component';
import ReplayIcon from '@material-ui/icons/ReplayOutlined';
import { Button } from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import usePermission from '../../hooks/usePermission';
import { UserPermission } from '../../enum/userPermissions';
import { viewType } from '../Layout/Layout.types';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';

const ErrorPage: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const { viewType } = useParams<{ viewType: viewType | undefined }>();

  const layoutViewType = (): viewType | undefined => {
    if (usePermission([UserPermission.AdminPanelManage, UserPermission.ExaminerDashboardRead])) {
      return !viewType ? 'admin' : viewType;
    } else if (usePermission(UserPermission.AdminPanelManage)) {
      return viewType;
    } else if (usePermission(UserPermission.ExaminerDashboardRead)) {
      return viewType;
    } else {
      return undefined;
    }
  };

  const handleOnClick = () => history.goBack();

  useDocumentTitle('Wystąpił błąd');

  return (
    <React.Fragment>
      <Layout viewType={layoutViewType()}>
        <ViewContainer>
          <div className={classes.grayContainer}>
            <AnnouncementIcon className={classes.icon} />
            <div className={classes.text}>
              Wystąpił błąd. Strona nie może zostać wyświetlona. Spróbuj ponownie później.
            </div>
            <Button className={classes.button} onClick={handleOnClick} variant="outlined" startIcon={<ReplayIcon />}>
              odśwież stronę
            </Button>
          </div>
        </ViewContainer>
      </Layout>
    </React.Fragment>
  );
};

export default ErrorPage;
